<template>
  <b-row id="main-div">
    <b-col id="left-filler-col"></b-col>
    <b-col id="center-col" cols="10">
      <div class="card">
        <div class="card-body">
          <b-overlay
            id="asd"
            :show="queryInProgress"
            variant="light"
            opacity="0.5"
            blur="2px"
            rounded="lg"
            ><!-- overlay -->
            <div class="row" id="coi-pagination">
              <div class="col-md-6">
                <div class="d-flex justify-content-start">
                  <h3 class="mt-2 pt-1">Benutzer-Index</h3>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-row justify-content-end">
                  <div class="d-flex flex-row-reverse">
                    <div class="py-2">
                      <b-button
                        size="sm"
                        v-if="canOpenCreateUserModal"
                        @click="openModalCreateUser()"
                        >Benutzer anlegen</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-table
              :items="users"
              :fields="fields"
              small
              :tbody-tr-class="userWasEdited"
            >
              <template v-slot:cell(name)="row" class="col-3">
                <span>{{ row.item.name }}</span>
                <b-badge v-if="!row.item.login_allowed" variant="warning"
                  >gesperrt</b-badge
                >
              </template>
              <template v-slot:cell(action)="row" class="col-3">
                <!-- b-input size="sm" v-if="row.item.id" v-model="row.item.action" / -->
                <!--b-row align-v="end" -->
                <b-button-group size="sm">
                  <b-button
                    size="sm"
                    @click="unlockCustomerOrder(row.item)"
                    :disabled="!row.item.lockedCustomerOrderId"
                    :variant="
                      row.item.lockedCustomerOrderId ? 'danger' : 'secondary'
                    "
                  >
                    <span
                      v-if="row.item.lockedCustomerOrderId"
                      class="icon icon-lock"
                      style="font-size: 1.5em"
                      variant="warning"
                    />
                    <span
                      v-else
                      class="icon icon-unlocked"
                      style="font-size: 1.5em"
                      size="sm"
                    />
                  </b-button>

                           <b-button
		                           v-if="auth.manager === true"
                              :id="`button-actions-popover-${row.item.id}`"
                              href="#"
                              tabindex="0"
                              size="sm"
		                           :disabled="auth.manager !== true"
                           >
                              <span class="icon icon-cogs" style="font-size: 1.5em" />
                           </b-button>
                        </b-button-group>
                        <b-popover
                           :target="`button-actions-popover-${row.item.id}`"
                           triggers="focus"
                        >
                           <b-button-group vertical>
                              <b-button
                                 v-if="canDisableUserAccounts"
                                 @click="toggleBlockUser(row.item)"
                                 variant="outline-secondary"
                                 ><!-- button -->
                                    Benutzer
                                    <span v-if="row.item.login_allowed">sperren</span>
                                    <span v-else                    >entsperren</span>
                              </b-button>
                              <b-button
                                 @click="openModalSetPassword(row.item)"
                                 variant="outline-secondary"
                                 v-if="canSetUserAccountPasswords"
                                 >Passwort neu vergeben</b-button
                              >
                              <b-button
                                 @click="openModalSetEmail(row.item)"
                                 variant="outline-secondary"
                             >Email neu vergeben
                             </b-button>

                    <b-button
                      @click="openModalSetShortname(row.item)"
                      variant="outline-secondary"
                      >Kürzel neu vergeben</b-button
                    >
                    <b-dropdown
                      v-if="canSetUserAccountAuthorizationLevel"
                      right
                      text="Rolle ändern"
                      variant="outline-secondary"
                      ><!-- dropdown -->
                      <b-dropdown-item
                        v-for="authorization of authLevels"
                        :key="authorization"
                        @click="setAuthorization(row.item, authorization)"
                        :active="authorization == row.item.role"
                        >{{ authorization }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </b-button-group>
                </b-popover>
              </template>
            </b-table>
            <modal-error-component v-model="modalError"></modal-error-component>
            <div v-if="selectedUser">
              <b-modal
                :title="`Passwort für Benutzer »${selectedUser.name}« ändern`"
                v-model="modalSetPassword_state"
                centered
                ><!-- modal -->
                <b-overlay
                  :show="setPasswordQueryInProgress"
                  variant="light"
                  opacity="0.5"
                  blur="2px"
                  rounded="lg"
                  ><!-- overlay -->
                  <div>
                    <b-input
                      v-model="selectedUser.password"
                      type="password"
                      placeholder="neues Passwort"
                      :state="passwordsMatch"
                      class="mb-1"
                    ></b-input>
                    <b-input
                      v-model="modalSetPassword_check"
                      type="password"
                      placeholder="… wiederholen"
                      :state="passwordsMatch"
                    ></b-input>
                  </div>
                </b-overlay>
                <template #modal-footer>
                  <div class="w-100">
                    <b-btn
                      size="md"
                      class="float-right mx-1"
                      @click="setPassword()"
                      variant="danger"
                      :disabled="!passwordsMatch"
                      >Passwort ändern</b-btn
                    >
                    <b-btn
                      size="md"
                      class="float-right"
                      @click="closeModalSetPassword()"
                      >Abbrechen</b-btn
                    >
                  </div>
                </template>
              </b-modal>

              <b-modal
                :title="`Email für Benutzer »${selectedUser.name}« ändern`"
                v-model="modalSetEmail_state"
                centered
                ><!-- modal -->
                <b-overlay
                  :show="setEmailQueryInProgress"
                  variant="light"
                  opacity="0.5"
                  blur="2px"
                  rounded="lg"
                  ><!-- overlay -->
                  <div>
                    <b-input
                      v-model="selectedUser.email"
                      type="email"
                      placeholder="neue Email"
                      class="mb-1"
                    ></b-input>
                  </div>
                </b-overlay>
                <template #modal-footer>
                  <div class="w-100">
                    <b-btn
                      size="md"
                      class="float-right mx-1"
                      @click="setEmail()"
                      variant="danger"
                      :disabled="!userValidEmailCheck"
                      >Email ändern</b-btn
                    >
                    <b-btn
                      size="md"
                      class="float-right"
                      @click="closeModalSetEmail()"
                      >Abbrechen</b-btn
                    >
                  </div>
                </template>
              </b-modal>

              <b-modal
                :title="`Kürzel für Benutzer »${selectedUser.name}« ändern`"
                v-model="modalSetShortname_state"
                centered
                ><!-- modal -->
                <b-overlay
                  :show="setShortnameQueryInProgress"
                  variant="light"
                  opacity="0.5"
                  blur="2px"
                  rounded="lg"
                  ><!-- overlay -->
                  <div>
                    <b-input
                      v-model="selectedUser.shortname"
                      type="text"
                      maxlength="2"
                      placeholder="neues Kürzel"
                      class="mb-1"
                    ></b-input>
                  </div>
                </b-overlay>
                <template #modal-footer>
                  <div class="w-100">
                    <b-btn
                      size="md"
                      class="float-right mx-1"
                      @click="setShortname()"
                      variant="danger"
                      :disabled="selectedUser.shortname.length != 2"
                      >Kürzel ändern</b-btn
                    >
                    <b-btn
                      size="md"
                      class="float-right"
                      @click="closeModalSetShortname()"
                      >Abbrechen</b-btn
                    >
                  </div>
                </template>
              </b-modal>
            </div>
          </b-overlay>
        </div>
      </div>
    </b-col>
    <b-col id="right-filler-col"></b-col>

    <b-modal
      id="modal-create-new-user"
      v-model="modalCreateUser_state"
      centered
      title="Neuen Benutzer anlegen"
    >
      <b-overlay
        :show="createUserQueryInProgress"
        variant="light"
        opacity="0.5"
        blur="2px"
        rounded="lg"
        ><!-- overlay -->
        <div v-if="newUser">
          <span v-if="newUser_errorMessage">{{ newUser_errorMessage }}</span>
          <form class="px-3">
            <div class="form-group row my-2">
              <label class="control-label col-4">Name</label>
              <input
                type="text"
                class="form-control form-control-sm col-8"
                v-model="newUser.name"
              />
            </div>
            <div class="form-group row my-2">
              <label class="control-label col-4">E-Mail</label>
              <b-input
                type="text"
                class="form-control form-control-sm col-8"
                v-model="newUser.email"
                :state="newUserValidEmail"
              ></b-input>
            </div>
            <div class="form-group row my-2">
              <label class="control-label col-4">Kürzel</label>
              <b-input
                type="text"
                class="form-control form-control-sm col-8"
                v-model="newUser.shortname"
                :state="newUserValidInitials"
              ></b-input>
            </div>
            <div class="form-group row my-2">
              <label class="control-label col-4">Passwort</label>
              <b-input
                v-model="newUser.password"
                type="password"
                placeholder="neues Passwort"
                :state="newUserPasswordsMatch"
                class="form-control form-control-sm col-8"
              ></b-input>
            </div>
            <div class="form-group row my-2">
              <label class="control-label col-4">… wiederholen</label>
              <b-input
                v-model="newUser.password_check"
                type="password"
                placeholder="neues Passwort"
                :state="newUserPasswordsMatch"
                class="form-control form-control-sm col-8"
              ></b-input>
            </div>

            <div class="form-group row my-2">
              <label class="control-label col-4">Rolle</label>
              <b-dropdown
                v-if="canSetUserAccountAuthorizationLevel"
                right
                :text="newUser.role"
                variant="outline-secondary"
                size="sm"
                class="form-control form-control-sm col-8 p-0"
                ><!-- dropdown -->
                <b-dropdown-item
                  v-for="authorization of authLevels"
                  :key="authorization"
                  @click="newUser.role = authorization"
                  :active="authorization == newUser.role"
                  style="padding-top: 0 !important"
                  >{{ authorization }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </form>
        </div>
      </b-overlay>
      <template #modal-footer>
        <div class="w-100">
          <b-btn
            size="md"
            class="float-right mx-1"
            @click="createUser()"
            variant="danger"
            :disabled="!canCreateUser"
            >Benutzer anlegen</b-btn
          >
          <b-btn size="md" class="float-right" @click="closeModalCreateUser()"
            >Abbrechen</b-btn
          >
        </div>
      </template>
    </b-modal>
  </b-row>
</template>
<script>
export default {
  props: [],
  data() {
    return {
      authLevels: [],
      auth: {
        account_assistant: false,
        account_manager: false,
        accountant: false,
        dev: false,
        mailer_manager: false,
        mailer: false,
        manager: false,
        master: false,
        shipper: false,
        shipping_assistant: false,
        shipping_manager: false,
        warehouse_manager: false,
      },
      createUserQueryInProgress: false,
      fields: [
        { key: "name", label: "Name", sortable: true /* tdClass: "col-3" */ },
        { key: "shortname", label: "Kürzel", sortable: true },
        { key: "email", label: "Email", sortable: true },
        {
          key: "lockedCustomerOrderId",
          label: "gesperrte Bestellung",
          sortable: true,
        },
        { key: "role", label: "", sortable: true },
        { key: "action", label: "", sortable: false },
      ],
      modalCreateUser_state: false,
      modalSetPassword_check: "",
      modalSetPassword_state: false,
      modalSetEmail_state: false,
      modalSetShortname_state: false,
      modalError: {
        show: false,
        message: "unpopulated",
        error: "unpopulated",
        title: "unpopulated",
      },
      newUser_errorMessage: null,
      newUser: null,
      queryInProgress: false,
      selectedUser: null,
      setPasswordQueryInProgress: false,
      setEmailQueryInProgress: false,
      setShortnameQueryInProgress: false,
      users: null,
    };
  },
  computed: {
    userWasEdited: function (user, type) {
      if (!user || type !== "row") return;
      if (user.wasEdited) return "table-success";
    },
    canDisableUserAccounts: function () {
      return this.auth.manager;
    },
    canSetUserAccountAuthorizationLevel: function () {
      return this.auth.manager;
    },
    canSetUserAccountPasswords: function () {
      return this.auth.manager;
    },
    canOpenCreateUserModal: function () {
      return this.auth.manager;
    },
    passwordsMatch: function () {
      if (!this.selectedUser) return false;
      if (!this.selectedUser.password) return false;
      if (0 == this.selectedUser.password.length) return false;
      return this.modalSetPassword_check == this.selectedUser.password;
    },
    newUserPasswordsMatch: function () {
      if (!this.newUser || this.newUser == null) return false;
      if (!this.newUser.password) return false;
      if (0 == this.newUser.password.length) return false;
      return this.newUser.password_check == this.newUser.password;
    },
    newUserValidInitials: function () {
      if (!this.newUser) return false;
      if (!this.newUser.shortname) return false;
      return null != this.newUser.shortname.match(/^[A-Z]{2,2}$/);
    },
    newUserValidEmail: function () {
      if (!this.newUser) return false;
      if (!this.newUser.email) return false;
      let dump = this.newUser.email.match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
      return null != dump;
    },
    userValidEmailCheck: function () {
      if (!this.selectedUser) return false;
      if (!this.selectedUser.email) return false;
      let dump = this.selectedUser.email.match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
      return null != dump;
    },
    canCreateUser: function () {
      if (!this.newUserPasswordsMatch) {
        this.newUser_errorMessage = "Passwörter stimmen nicht überein.";
        return false;
      }
      if (!this.newUserValidInitials) {
        this.newUser_errorMessage =
          "Kürzel musss aus 2 Großbuchstaben bestehen.";
        return false;
      }

      //check if user already exists.
      const maybe = this.users.find(
        (other) =>
          other.name == this.newUser.name || other.email == this.newUser.email,
      );
      if (null != maybe) {
        this.newUser_errorMessage =
          "Der Gewünschte Name und/oder Email ist bereits in Verwendung.";
        return false;
      }
      this.newUser_errorMessage = "";
      return true;
    },
  },
  methods: {
    setAuthorization(user, authorization) {
      if (!this.auth[authorization]) return;
      axios
        .post("/user/authorization/set", {
          userId: user.id,
          role: authorization,
        })
        .then((response) => {
          user.role = authorization;
          this.$root.$emit("bv::hide::popover");
        })
        .catch((error) => {
          alert("Konnte Rolle nicht ändern");
          console.error(error);
        });
    },
    getUsers(maybeUserId) {
      this.queryInProgress = true;
      return new Promise((resolve, reject) => {
        Promise.all([
          axios.get("/user/get"),
          new Promise((r) => setTimeout(r, 333)),
        ])
          .then(([response]) => {
            this.users = response.data.sort(
              (v, w) => new Date(w.updated_at) - new Date(v.updated_at),
            );
            this.queryInProgress = false;
            if (maybeUserId)
              this.users.find((user) => user.id == maybeUserId).wasEdited =
                true;
            resolve();
          })
          .catch(() => {
            alert("etwas ist schief gelaufen.");
            this.queryInProgress = false;
            reject();
          });
      });
    },
    createUser() {
      this.createUserQueryInProgress = true;
      axios
        .post("/user/create", {
          name: this.newUser.name,
          email: this.newUser.email,
          shortname: this.newUser.shortname,
          role: this.newUser.role,
					password: this.newUser.password,
        })
        .then((response) => {
          this.createUserQueryInProgress = false;
          this.closeModalCreateUser();
          this.getUsers();
        })
        .catch((error) => {
          this.createUserQueryInProgress = false;
          alert("konnte Benutzer nicht anlegen.");
          console.log(error);
        });
    },
    unlockCustomerOrder(user) {
      console.log("+++ unlockCustomerOrder");
      this.queryInProgress = true;
      axios
        .post("/user/unlock_customer_order/" + user.id)
        .then((response) => {
          console.log(response);
          this.$root.$emit("bv::hide::popover");
          this.getUsers(user.id);
        })
        .catch((err) => {
          this.queryInProgress = false;
          console.error(err);
          alert("ein fehler ist beim Unlock-Prozess aufgetreten.d");
        });
    },
    toggleBlockUser(user) {
      this.queryInProgress = true;
      axios
        .get(`user/block/${user.id}`)
        .then((response) => {
          this.queryInProgress = false;
          this.getUsers(user.id);
          this.$root.$emit("bv::hide::popover");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    openModalCreateUser() {
      this.newUser = {
        name: "",
        email: "",
        password: "",
        role: "",
        shortname: "",
      };
      this.modalCreateUser_state = true;
    },
    closeModalCreateUser() {
      this.newUser = null;
      this.modalCreateUser_state = false;
    },
    openModalSetPassword(user) {
      this.selectedUser = user;
      this.modalSetPassword_state = true;
    },
    openModalSetEmail(user) {
      this.selectedUser = user;
      this.modalSetEmail_state = true;
    },
    openModalSetShortname(user) {
      this.selectedUser = user;
      this.modalSetShortname_state = true;
    },
    closeModalSetPassword() {
      this.selectedUser = null;
      this.modalSetPassword_check = "";
      this.modalSetPassword_state = false;
    },
    closeModalSetEmail() {
      this.selectedUser = null;

      this.modalSetEmail_state = false;
    },
    closeModalSetShortname() {
      this.selectedUser = null;
      this.selectedUser = null;
      this.modalSetShortname_state = false;
    },
    setPassword() {
      if (this.modalSetPassword_check != this.selectedUser.password) {
        alert("passwörter sind nicht gleich.");
      }
      this.setPasswordQueryInProgress = true;
      Promise.all([
        axios.post(`user/password/set`, {
          userId: this.selectedUser.id,
          password: this.selectedUser.password,
        }),
        new Promise((r) => setTimeout(r, 750)),
      ])
        .then(([response]) => {
          this.$root.$emit("bv::hide::popover");
          this.getUsers(this.selectedUser.id);
          this.closeModalSetPassword();
          this.setPasswordQueryInProgress = false;
        })
        .catch((error) => {
          alert("Konnte Passwort nicht ändern.");
          this.setPasswordQueryInProgress = false;
        });
    },
    setEmail() {
      this.setShortnameQueryInProgress = true;
      Promise.all([
        axios.post(`user/email/set`, {
          userId: this.selectedUser.id,
          email: this.selectedUser.email,
        }),
        new Promise((r) => setTimeout(r, 750)),
      ])
        .then(([response]) => {
          this.$root.$emit("bv::hide::popover");
          this.getUsers(this.selectedUser.id);
          this.closeModalSetEmail();
          this.setEmailQueryInProgress = false;
        })
        .catch((error) => {
          alert(error);
          // alert("Konnte Email nicht ändern.");
          this.setEmailQueryInProgress = false;
        });
    },
    setShortname() {
      this.setShortnameQueryInProgress = true;
      Promise.all([
        axios.post(`user/shortname/set`, {
          userId: this.selectedUser.id,
          shortname: this.selectedUser.shortname,
        }),
        new Promise((r) => setTimeout(r, 750)),
      ])
        .then(([response]) => {
          this.$root.$emit("bv::hide::popover");
          this.getUsers(this.selectedUser.id);
          this.closeModalSetShortname();
          this.setShortnameQueryInProgress = false;
        })
        .catch((error) => {
          alert(error);
          // alert("Konnte Kürzel nicht ändern.");
          this.setShortnameQueryInProgress = false;
        });
    },
  },
  created() {
    Promise.all([
      this.getUsers(),
      axios.get("/user/authorization"),
      axios.get("/user/authorization/all"),
    ])
      .then(([nothing, response, responseAuthLevels]) => {
        this.auth = response.data;
        this.authLevels = responseAuthLevels.data;
      })
      .catch((error) => {
        alert("Daten konnten nicht runtergeladen werden.");
        console.error(error);
      });
  },
};
</script>
